import axios from "@/axios-instance";

export async function getZeltyRestaurants(merchantId, apiKey){
    return new Promise(((resolve, reject) => {
        axios.post('/v1/merchants/'+merchantId+'/integrations/zelty/getRestaurants', {api_key: apiKey})
            .then((response) => {
                resolve(response.data.restaurants);
            })
            .catch((error) => {
                reject(error);
            })
    }));
}

export async function getZeltyMenus(merchantId, apiKey){
    return new Promise(((resolve, reject) => {
        axios.post('/v1/merchants/'+merchantId+'/integrations/zelty/getMenus', {api_key: apiKey})
            .then((response) => {
                resolve(response.data.ratemakings);
            })
            .catch((error) => {
                reject(error);
            })
    }));
}
export async function getZeltyPaymentMethods(merchantId, apiKey){
    return new Promise(((resolve, reject) => {
        axios.post('/v1/merchants/'+merchantId+'/integrations/zelty/getPaymentMethods', {api_key: apiKey})
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            })
    }));
}

export async function saveZeltyIntegration(merchantId, api_key, restaurant_id, menu_id, menu_name, transaction_method_id){
    return new Promise(((resolve, reject) => {
        axios.post('/v1/merchants/'+merchantId+'/integrations/zelty/save', {api_key, restaurant_id, menu_id, menu_name, transaction_method_id})
            .then((response) => {
                resolve(response.data.ratemakings);
            })
            .catch((error) => {
                reject(error);
            })
    }));
}

export async function zeltyDisconnect(merchantId){
    return new Promise(((resolve, reject) => {
        axios.post('/v1/merchants/'+merchantId+'/integrations/zelty/disconnect')
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            })
    }));
}
